module.exports = __webpack_public_path__ + "static/img/IMG_20240816_172110.d83f991a.jpg";